'use client';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import { Check, ClipboardCopyIcon } from 'lucide-react';
import { Button } from '../ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { useToast } from '../../hooks/use-toast';
import { cn } from '../../lib/utils';
export function CopyToClipboardButton(_a) {
    var _this = this;
    var className = _a.className, _b = _a.size, size = _b === void 0 ? 'icon' : _b, stringToCopy = _a.stringToCopy, _c = _a.variant, variant = _c === void 0 ? 'ghost' : _c, _d = _a.hideTooltip, hideTooltip = _d === void 0 ? false : _d, _e = _a.tooltipText, tooltipText = _e === void 0 ? 'Copy to clipboard' : _e, _f = _a.position, position = _f === void 0 ? 'left' : _f, children = _a.children;
    var toast = useToast().toast;
    var _g = useState(false), isCopied = _g[0], setIsCopied = _g[1];
    var _h = useState(false), tooltipOpen = _h[0], setTooltipOpen = _h[1];
    var handleCopy = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    e.preventDefault();
                    e.stopPropagation();
                    return [4 /*yield*/, navigator.clipboard.writeText(stringToCopy)];
                case 1:
                    _b.sent();
                    setIsCopied(true);
                    setTooltipOpen(true);
                    setTimeout(function () {
                        setIsCopied(false);
                        setTooltipOpen(false);
                    }, 800);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    toast({
                        description: 'Unable to copy to clipboard.',
                        title: 'Failed to copy',
                        variant: 'destructive',
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var Icon = (<>
      <div className="relative">
        <ClipboardCopyIcon className={cn('h-3 w-3 transition-all duration-200', isCopied ? 'scale-0 opacity-0' : 'scale-100 opacity-100')}/>
        <Check className={cn('text-success-foreground absolute inset-0 h-3 w-3 transition-all duration-200', isCopied ? 'scale-100 opacity-100' : 'scale-0 opacity-0')}/>
      </div>
      <span className="sr-only">{tooltipText}</span>
    </>);
    return (<Tooltip open={tooltipOpen} onOpenChange={setTooltipOpen}>
      <TooltipTrigger asChild>
        <Button className={cn('h-6 w-6 shrink-0', className)} onClick={handleCopy} size={size} type="button" variant={variant}>
          {position === 'left' && Icon}
          {children}
          {position === 'right' && Icon}
        </Button>
      </TooltipTrigger>
      {!hideTooltip && (<TooltipContent>
          <p>{isCopied ? 'Copied!' : tooltipText}</p>
        </TooltipContent>)}
    </Tooltip>);
}
